import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateRfidCardDialogContentComponent } from './create-rfid-card-dialog-content/create-rfid-card-dialog-content.component';

@Component({
  selector: 'app-create-rfid-card-dialog',
  template: ''
})
export class CreateRfidCardDialogComponent implements OnInit {

  constructor(
    public dialog: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var customerId = this.activatedRoute.parent.parent.snapshot.params.key;

    const dialogRef = this.dialog.open(CreateRfidCardDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.customerId = customerId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    });
  }

}
